import React, { useEffect, useState } from 'react';
import { Modal, Tabs } from 'antd';
import ModalLogin from '../modalLogin';
import ModalRegistration from '../modalRegistration';
import ModalResetPassword from '../modalResetPassword';
import './modalWindow.scss';

const ModalWindow: React.FC<{ visible: boolean; onCancel: () => void; }> = ({ visible, onCancel }) => {
    const [activeTab, setActiveTab] = useState('login');

    const authTabs = [
        {
            key: 'login',
            label: 'Login',
            children: <ModalLogin onCancel={onCancel} />,
        },
        {
            key: 'register',
            label: 'Register',
            children: <ModalRegistration onCancel={onCancel} />,
        },
        {
            key: 'reset',
            label: 'Reset Password',
            children: <ModalResetPassword onCancel={onCancel} />,
        },
    ];

    useEffect(() => {
        if (!visible) return undefined;

        const closeOnEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape') onCancel();
        };

        document.addEventListener('keydown', closeOnEscape);
        return () => document.removeEventListener('keydown', closeOnEscape);
    }, [onCancel, visible]);

    return (
        <Modal
            title="Authentication"
            open={visible}
            onCancel={onCancel}
            footer={null}
            wrapClassName="authentication-modal"
            keyboard
        >
            <Tabs activeKey={activeTab} onChange={setActiveTab} items={authTabs} />
        </Modal>
    );
};

export default ModalWindow;
